export default __webpack_public_path__ + "static/media/LukeChoi.ed35cd78.JPG";